export default {
  name: 'select',
  type: 'action',
  isRequired: true,
  essential: false
}
